<template>
    <div class="form-container">
        <el-form :label-width="labelWidth" class="form-content" ref="ruleFormRef"
            :model="modelValue">
            <el-row v-for="item in attrData">
                <template  >
                    <el-col :span="12">
                        <el-form-item v-bind='item'
                        :label="item.alias" :prop="item.name"
                        :rules="{required: true, message: '不可为空', trigger: 'change,blur'}">
                            <template v-if="item.form_type === 'text'">
                                <el-input laceholder="请输入" clearable
                                 :model-value="modelValue[`${item.name}`]"/>
                             </template>
                            <template v-if="item.form_type === 'select'">
                                <el-select clearable placeholder="请选择"
                                    v-model="modelValue[`${item.name}`]"
                                    >
                                    <el-option
                                        v-for="optionItem in dictionary[item.ddt]"
                                        :label="optionItem.cname"
                                        :value="optionItem.ename"
                                        :key="optionItem.id" ></el-option>
                                </el-select>
                            </template>
                            <template v-if="item.form_type === 'integer'&& item.value_type === 'v_int'">
                                <el-input-number v-model="modelValue[`${item.name}`]" :precision="0"  :min="1" label=""></el-input-number>
                            </template>
                            <template v-if="item.form_type === 'integer'&& item.value_type === 'v_list'">

                                <el-table :data="tableData" style="width: 100%" max-height="250">
                                    <el-table-column  prop="sizeData" label="容量（G）" >
                                        <template slot-scope="scope">
                                            <el-input-number v-model="scope.row.sizeData" :precision="0"  :min="1" label=""></el-input-number>
                                        </template>
                                    </el-table-column>
                                    <el-table-column fixed="right" label="操作" width="120">
                                        <template slot-scope="scope">
                                            <el-button @click.native.prevent="deleteRow(scope.$index, tableData)"
                                                type="text" > 移除 </el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>

                                <el-button type="text" @click="addRow">添加 ({{tableData.length}}/8)</el-button>
                                <span v-if="tableData.length+1 > 8" style="color:red;">最多只能添加8个</span>
                            </template>
<!--                            <template v-if="item.form_type === 'integer'">-->
<!--                                <el-slider v-model="modelValue[`${item.name}`]"></el-slider>-->
<!--                            </template>-->
                        </el-form-item>
                    </el-col>
                </template>

            </el-row>

        </el-form>
    </div>
</template>
<script>
export default {
    props:{
        attrData:{type:Array,default:[]},
        specification:{type:Object,default:null},
        type:{type:String,default:'add'}
    },
    data(){
        return{
            formName:'ruleFormRef',
            formItems:[],
            labelWidth: '120px',
            modelValue:{},
            tableData:[{sizeData:1}],
            colLayout: {
                xl: 5,
                lg: 8,
                md: 12,
                sm: 24,
                xs: 24
            }
        }
    },
    computed:{
        dictionary(){
            return this.$store.state.dictionary;
        },
    },
    watch:{

        specification:{
            handler(newVal,oldVal){
                if(newVal !== null){
                    // console.log(newVal)
                    this.modelValue = {...newVal}
                    if(this.modelValue['hd_size_list'].length>0){
                        this.tableData = []
                        this.modelValue['hd_size_list'].map(item=>{
                            this.tableData.push({sizeData:item})
                        })

                    }

                }
            },
            deep:true,
            immediate:true
        },
        // tableData:{
        //     handler(newVal,oldVal){

        //         if(newVal.length>0){
        //             if(this.type == 'add'){
        //                 this.modelValue['hd_size_list'] = []
        //             }
        //             newVal.map(item =>{
        //                 this.modelValue['hd_size_list'].push(item.sizeData)
        //             })
        //         }
        //     },
        //     // deep:true,
        //     // immediate:true
        // }
    },
    mounted() {

    },
    methods: {
        addRow(){
            if(this.tableData.length<8){
                this.tableData.push({sizeData:0})
            }
        },
        deleteRow(index, rows) {
            rows.splice(index, 1);
        },
        getHdSizeList(){
            this.modelValue['hd_size_list'] = []
            this.tableData.map(item=>{
                this.modelValue['hd_size_list'].push(item.sizeData)
            })
        },
        onSubmit(){
            let formName = this.formName;
            this.getHdSizeList()
            let flag = false
            this.$refs[formName].validate((valid) => {
                valid ? flag = true: flag = false
                return valid;
            })
            return flag
        }
    }
}
</script>
<style scoped lang="scss">

</style>
